import { render } from "./servidores.vue?vue&type=template&id=b5c64b58&scoped=true"
import script from "./servidores.vue?vue&type=script&lang=js"
export * from "./servidores.vue?vue&type=script&lang=js"

import "./servidores.vue?vue&type=style&index=0&id=b5c64b58&lang=scss&scoped=true"
import "./servidores.vue?vue&type=style&index=1&id=b5c64b58&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c64b58"]])

export default __exports__